import { render, staticRenderFns } from "./BetaTag.vue?vue&type=template&id=19f764bf&scoped=true&"
var script = {}
import style0 from "./BetaTag.vue?vue&type=style&index=0&id=19f764bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f764bf",
  null
  
)

export default component.exports